import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

//material ui components:
import { withStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography, TextField } from '@material-ui/core';

import Top5 from './top5';

//actions:
import { modifyFieldOtrosDatos } from '../../../actions/cierre_diario_actions';
import { setSaveState } from '../../../actions';

//components:
import IntNumberFormatInput from '../../../components/int_number_input_formatter';
import FloatNumberFormatInput from '../../../components/float_number_input_formatter';

//styles:
const styles = theme => ({
    container: {
        padding: 0,
        marginBottom: 5,
        fontSize: 13,
        fontWeight: '600',
        margin: '0 8px',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        height: 155,
    },
    paperTitle: {
        fontSize: 13,
        fontWeight: '500',
        margin: 0,
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        padding: '4px 2px 4px 12px',
    },
    containerItems: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: 130,
    },
    singleItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '2px 15px',
    },
    label: {
        maxWidth: 85,
        fontSize: 11,
    },
    input: {
        width: 60,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    inputImporte: {
        textAlign: 'right',
        margin: '8px 8px 8px 2px',
        padding: 0,
        fontSize: 12,
    },
});
class ThirdRowPapers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            //marketing:
            numeroPersonas: !this.props.otrosDatosCierreDiario.numeroPersonas ? 0 : this.props.otrosDatosCierreDiario.numeroPersonas,
            extrasVendidos: !this.props.otrosDatosCierreDiario.extrasVendidos ? 0 : this.props.otrosDatosCierreDiario.extrasVendidos,
            tokensEntregados: !this.props.otrosDatosCierreDiario.tokensEntregados ? 0 : this.props.otrosDatosCierreDiario.tokensEntregados,
        };
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //once we get the data:
        if (prevProps.otrosDatosCierreDiario !== this.props.otrosDatosCierreDiario) {
            this.setState({
                //marketing:
                numeroPersonas: !this.props.otrosDatosCierreDiario.numeroPersonas ? 0 : this.props.otrosDatosCierreDiario.numeroPersonas,
                extrasVendidos: !this.props.otrosDatosCierreDiario.extrasVendidos ? 0 : this.props.otrosDatosCierreDiario.extrasVendidos,
                tokensEntregados: !this.props.otrosDatosCierreDiario.tokensEntregados ? 0 : this.props.otrosDatosCierreDiario.tokensEntregados,
            });
        };
    };


    handleValueChange = (event, field) => {

        this.setState({ ...this.state, [field]: event.target.value });
    };


    onBlur = (event, field) => {

        // const value = !event.target.value ? 0 : parseInt(event.target.value);

        this.props.setSaveState(true);
        this.props.modifyFieldOtrosDatos(field, this.state[field]);
    };

    render() {

        const { classes } = this.props;

        return (
            <Grid container style={{ marginBottom: 5, height: 115 }}>

                {/* third row: top5 y marketing */}
                <Top5 />


                <Grid item xs={4} >
                    {/* MKTING */}
                    <Paper className={classes.container} elevation={0}>
                        <h5 className={classes.paperTitle}>Marketing</h5>

                        <div className={classes.containerItems}>
                            <div className={classes.singleItem} >
                                {/* first label and input*/}
                                <Typography variant="subtitle2" className={classes.label}>Número Personas</Typography>
                                <TextField
                                    disabled={this.props.isDiaCerrado ? true : false}
                                    // placeholder={'0'}
                                    className={classes.input}
                                    id={'numeroPersonas'}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                    value={this.state.numeroPersonas}
                                    onChange={(event) => this.handleValueChange(event, 'numeroPersonas')}
                                    onBlur={(event) => this.onBlur(event, 'numeroPersonas')}
                                    variant='outlined'
                                />
                            </div>
                            <div className={classes.singleItem} >
                                {/* second label and input*/}
                                <Typography variant="subtitle2" className={classes.label}>Extras Vendidos €</Typography>
                                <TextField
                                    disabled={this.props.isDiaCerrado ? true : false}
                                    // placeholder={'0'}
                                    className={classes.input}
                                    id={'extrasVendidos'}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                                    value={this.state.extrasVendidos}
                                    onChange={(event) => this.handleValueChange(event, 'extrasVendidos')}
                                    onBlur={(event) => this.onBlur(event, 'extrasVendidos')}
                                    variant='outlined'
                                />
                            </div>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        );
    };
};


ThirdRowPapers.propTypes = {
    otrosDatosCierreDiario: PropTypes.object.isRequired,
    modifyFieldOtrosDatos: PropTypes.func.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
};


function mapStateToProps(state) {
    return {
        otrosDatosCierreDiario: state.otrosDatosCierreDiario.datos,
        tieneTokens: state.otrosDatosCierreDiario.tieneTokens,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyFieldOtrosDatos,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(ThirdRowPapers));
